export const faqList = [
  {
    question: '91n.com 是什么平台？',
    answer: '91n.com 是一个综合性网络信息与服务平台，提供信息浏览、资源获取、互动交流等多种功能。用户可以通过 91n.com 获取最新资讯、使用平台工具、参与社区讨论等。',
  },
  {
    question: '如何注册 91n.com 账号？',
    answer: '访问 91n.com 官方网站，点击右上角的"注册"按钮，填写用户名、邮箱和密码等基本信息，完成邮箱验证后即可成功注册。详细步骤可参考"新用户注册完整流程指南"。',
  },
  {
    question: '忘记 91n.com 密码怎么办？',
    answer: '在 91n.com 登录页面点击"忘记密码"，通过绑定的邮箱或手机号接收验证信息，按照提示即可重置密码。如果绑定的信息已失效，请联系客服协助处理。',
  },
  {
    question: '91n.com 是否免费使用？',
    answer: '91n.com 的基础功能完全免费，用户可以自由注册和使用。部分高级功能可能需要开通会员服务，具体以平台实际展示为准。',
  },
  {
    question: '如何确保 91n.com 账号安全？',
    answer: '建议开启二次验证、设置强密码、绑定有效的邮箱和手机号、定期检查登录记录。同时请认准 91n.com 唯一官方域名，避免在仿冒网站输入账号信息。',
  },
  {
    question: '91n.com 的最新官方入口地址是什么？',
    answer: '91n.com 的唯一官方域名即为 91n.com。建议您收藏该网址，或通过搜索引擎搜索"91n.com 官方"来访问。请务必认准官方域名，谨防钓鱼网站。',
  },
  {
    question: '收不到 91n.com 的验证邮件怎么办？',
    answer: '请先检查垃圾邮件箱，确认邮箱地址正确，然后尝试重新发送验证邮件。如仍无法收到，建议更换其他邮箱服务商尝试，或联系客服获取帮助。',
  },
  {
    question: '如何联系 91n.com 官方客服？',
    answer: '您可以通过以下方式联系我们：发送邮件至 support@91n.com，在工作时间内我们会尽快回复。也可以访问"关于我们"页面获取更多联系方式。',
  },
  {
    question: '91n.com 支持哪些设备访问？',
    answer: '91n.com 全面支持桌面电脑、平板和手机等多种设备访问，界面会根据设备自动适配，确保您在任何设备上都能获得良好的使用体验。',
  },
  {
    question: '如何注销 91n.com 账号？',
    answer: '登录 91n.com 后，进入账号设置页面，在安全设置中可找到"账号注销"选项。请仔细阅读注销须知后进行确认操作。注销后相关数据将按照平台隐私政策处理。',
  },
];